import { render, staticRenderFns } from "./AdminShortenUrlEdit.vue?vue&type=template&id=55532a82"
import script from "./AdminShortenUrlEdit.vue?vue&type=script&lang=js"
export * from "./AdminShortenUrlEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports